import { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { downloadTemporaryFileRequest } from "../../../../utils/APICalls";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import UndoOutlinedIcon from "@mui/icons-material/UndoOutlined";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useSortable } from "@dnd-kit/react/sortable";

export default function QCPhotosList({
  id,
  photoData,
  index,
  onDescriptionUpdate,
  onDelete,
  onDeleteUndo,
}: any) {
  const { ref, handleRef } = useSortable({ id, index });
  const [photoUrl, setPhotoUrl] = useState("");
  const [description, setDescription] = useState<string | null>(null);

  const prevKeyRef = useRef(null);
  const prevDescriptionRef = useRef(null);

  useEffect(() => {
    if (photoData) {
      if (photoData.key !== prevKeyRef.current) {
        prevKeyRef.current = photoData.key;
        getPhotoUrl(photoData.key);
      } else if (photoData.file) {
        const imageUrl = URL.createObjectURL(photoData?.file);
        setPhotoUrl(imageUrl);
      }
      if (photoData.description !== prevDescriptionRef.current) {
        prevDescriptionRef.current = photoData.description;
        setDescription(photoData.description);
      }
    }
  }, [photoData]);

  const getPhotoUrl = async (key: string) => {
    const response = await downloadTemporaryFileRequest(key);
    if (response && response.data) {
      setPhotoUrl(response.data);
    }
  };

  return (
    <>
      {photoData?.isDeleted ? (
        <Box
          sx={{
            border: "1px solid #C4C4C4",
            p: 1,
            display: "flex",
            mt: 1,
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 1,
          }}
        >
          <Typography color="error" fontStyle={"italic"}>
            Image Deleted
          </Typography>
          <Button
            variant="text"
            startIcon={<UndoOutlinedIcon />}
            onClick={() => onDeleteUndo(index)}
          >
            Undo
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            border: "1px solid #C4C4C4",
            p: 2,
            display: "flex",
            mt: 1,
            borderRadius: 1,
          }}
          ref={ref}
        >
          <Box
            sx={{
              width: 300,
              minWidth: 300,
              maxWidth: 300,
              height: 200,
              position: "relative",
            }}
          >
            {!photoUrl ? (
              <CircularProgress
                size={24}
                sx={{ position: "absolute", top: "45%", left: "45%" }}
              />
            ) : (
              <Box
                component="img"
                src={photoUrl}
                alt="Photo"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            )}
          </Box>
          <TextField
            sx={{ width: "100%", mx: 2 }}
            id="description-multiline"
            label="Description"
            multiline
            rows={4}
            value={description || ""}
            onChange={(e) => {
              setDescription(e.target.value);
              onDescriptionUpdate(index, e.target.value);
            }}
          />
          <IconButton
            sx={{ height: 40 }}
            aria-label="delete"
            onClick={() => onDelete(index)}
          >
            <DeleteOutlinedIcon color="error" />
          </IconButton>
          <IconButton sx={{ height: 40 }} aria-label="drag" ref={handleRef}>
            <DragIndicatorIcon color="primary" />
          </IconButton>
        </Box>
      )}
    </>
  );
}
